import api from './api';

export const getActiveDemandTypes = async () => {
  const response = await api.get('/api/private/demand-types');
  return response.data;
};

export const getAdminDemandTypes = async () => {
  const response = await api.get('/api/private/demand-types/admin', {
    params: { includeInactive: true },
  });
  return response.data;
};

export const createDemandType = async (payload) => {
  const response = await api.post('/api/private/demand-types', payload);
  return response.data;
};

export const updateDemandType = async (id, payload) => {
  const response = await api.put(`/api/private/demand-types/${id}`, payload);
  return response.data;
};

export const deleteDemandType = async (id) => {
  await api.delete(`/api/private/demand-types/${id}`);
};
